import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VeeValidate from 'vee-validate'
import './plugins/vuetify'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'

// Replacing Alertifyjs with vue-toast-notification
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'

export const eventBus = new Vue()
// import { MdIcon } from 'vue-material/dist/components'
// import 'vue-material/dist/vue-material.min.css'

Vue.use(VeeValidate)

Vue.use(VueToast, { position: 'top' })

// Vue.use(MdIcon)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
